import { render, staticRenderFns } from "./DigitalSignageTVForgotPassword.vue?vue&type=template&id=2764c9ed&scoped=true"
import script from "./DigitalSignageTVForgotPassword.ts?vue&type=script&lang=ts&external"
export * from "./DigitalSignageTVForgotPassword.ts?vue&type=script&lang=ts&external"
import style0 from "./DigitalSignageTVForgotPassword.scss?vue&type=style&index=0&id=2764c9ed&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2764c9ed",
  null
  
)

export default component.exports